import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";


import EditServiceLayer from "../components/EditServiceLayer";


const EditServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Service" />

        {/* AddUserLayer */}
        <EditServiceLayer />


      </MasterLayout>
    </>
  );
};

export default EditServicePage;
